import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TransactionsPage } from './pages/Transactions';
import { TransactionDetailPage } from './pages/TransactionDetail';
import { ParseFailedPage } from './pages/ParseFailed';
import { LoginPage } from './pages/Login';
import { AdminPage } from './pages/Admin';
import { AdminDepartmentsPage } from './pages/AdminDepartments';
import { AdminDepartmentEditPage } from './pages/AdminDepartmentEdit';
import { AdminCardsPage } from './pages/AdminCards';
import { AdminCardEditPage } from './pages/AdminCardEdit';
import { AdminStatementsPage } from './pages/AdminStatements';
import { AdminUsersPage } from './pages/AdminUsers';
import { AdminUserNewPage } from './pages/AdminUserNew';
import { AdminUserEditPage } from './pages/AdminUserEdit';
import { PendingPage } from './pages/Pending';
import { AlertsPage } from './pages/Alerts';
import { HomePage } from './pages/Home';
import { Layout } from './components/Layout';
import { CommandPalette } from './components/CommandPalette';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <CommandPalette />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/transactions"
            element={
              <Layout>
                <TransactionsPage />
              </Layout>
            }
          />
          <Route
            path="/transactions/:id"
            element={
              <Layout>
                <TransactionDetailPage />
              </Layout>
            }
          />
          <Route
            path="/pending"
            element={
              <Layout>
                <PendingPage />
              </Layout>
            }
          />
          <Route
            path="/parse-failed"
            element={
              <Layout>
                <ParseFailedPage />
              </Layout>
            }
          />
          <Route
            path="/admin"
            element={
              <Layout>
                <AdminPage />
              </Layout>
            }
          />
          <Route
            path="/admin/departments"
            element={
              <Layout>
                <AdminDepartmentsPage />
              </Layout>
            }
          />
          <Route
            path="/admin/departments/new"
            element={
              <Layout>
                <AdminDepartmentEditPage />
              </Layout>
            }
          />
          <Route
            path="/admin/departments/:id/edit"
            element={
              <Layout>
                <AdminDepartmentEditPage />
              </Layout>
            }
          />
          <Route
            path="/admin/cards"
            element={
              <Layout>
                <AdminCardsPage />
              </Layout>
            }
          />
          <Route
            path="/admin/cards/new"
            element={
              <Layout>
                <AdminCardEditPage />
              </Layout>
            }
          />
          <Route
            path="/admin/cards/:id/edit"
            element={
              <Layout>
                <AdminCardEditPage />
              </Layout>
            }
          />
          <Route
            path="/admin/statements"
            element={
              <Layout>
                <AdminStatementsPage />
              </Layout>
            }
          />
          <Route
            path="/admin/users"
            element={
              <Layout>
                <AdminUsersPage />
              </Layout>
            }
          />
          <Route
            path="/admin/users/new"
            element={
              <Layout>
                <AdminUserNewPage />
              </Layout>
            }
          />
          <Route
            path="/admin/users/:id/edit"
            element={
              <Layout>
                <AdminUserEditPage />
              </Layout>
            }
          />
          <Route
            path="/alerts"
            element={
              <Layout>
                <AlertsPage />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
